import axios from "axios";

export default function ScheduleitemShowService(scheduleitemId) {

  return axios({
    method: 'get',
    url: process.env.REACT_APP_API_HOST + "/schedule_item/" + scheduleitemId,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
